import { LBButton } from '@linearb/buzz';
import AIDashboardEmptyStateImage from 'images/AIDashboardEmptyStateImage.svg';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { REPORT_IDS } from 'views/root/views/home/views/performance/views/CustomReport/consts';

const AIEmptyState = () => {
  return (
    <div className='flex rounded-md border border-gray-300 px-10 py-20'>
      <div className='flex flex-1 flex-col justify-center'>
        <h1 className='mb-4 text-4xl font-semibold leading-tight'>
          No AI Code Review
          <br />
          Data available
        </h1>
        <p className='mb-6 text-base text-zinc-500'>
          This dashboard is empty because you haven't started using AI Code
          Review.
        </p>
        <div className='space-y-2'>
          <h2 className='text-xl font-bold text-zinc-500'>
            Supercharge Your Code Reviews
          </h2>
          <p className='text-base text-gray-600'>
            Enable AI Code Review to detect bugs, security risks, and more{' '}
            <br />- before your team spends time reviewing.
          </p>
          <h2 className='text-xl font-bold'>
            AI Code Review is included in your package.
          </h2>
          <div className='w-20 pt-4'>
            <LBButton
              onClick={() => {
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.METRICS,
                  dashboard_name: REPORT_IDS.AI_CODE_REVIEW,
                  click_type: TRACKING.CLICK.ENABLE_NOW_AI_CODE_REVIEW
                });

                window.open(
                  'https://docs.gitstream.cm/automations/integrations/LinearBAI/code-review'
                );
              }}
            >
              Enable Now
            </LBButton>
          </div>
        </div>
      </div>

      <div className='flex flex-1 items-center justify-center'>
        <img
          src={AIDashboardEmptyStateImage}
          alt='AI Dashboard Empty State Illustration'
          className='max-h-[300px] max-w-full'
        />
      </div>
    </div>
  );
};

export default AIEmptyState;
